import {IndicatorIconWrapperDefaultBox} from "./indicator-icon-wrapper-default.box";
import {styledByDevice} from "../../../themes/architecture/styled-by-device";
import styled from "styled-components";

const IndicatorIconWrapperSICommonBox = styled(IndicatorIconWrapperDefaultBox)`
    border-radius: 50%;
    margin-bottom:  1rem;
    background: ${({theme}) => theme.colors.backgroundDark};
`;

const IndicatorIconWrapperSIforPCBox = styled(IndicatorIconWrapperSICommonBox)`
`;

const IndicatorIconWrapperSIforMobileBox = styled(IndicatorIconWrapperSICommonBox)`
    position: relative;
`;

export const IndicatorIconWrapperSIBox = styledByDevice(IndicatorIconWrapperSIforPCBox, IndicatorIconWrapperSIforMobileBox);